import * as echarts from 'echarts/core';
import {
  BarChart, LineChart, PieChart, GaugeChart, HeatmapChart, ScatterChart, FunnelChart, TreemapChart, RadarChart,
  SankeyChart, SunburstChart, CustomChart, BoxplotChart, PictorialBarChart
} from 'echarts/charts';
import {
  GridComponent, TooltipComponent, LegendComponent, TitleComponent, ToolboxComponent,
  DataZoomComponent, VisualMapComponent, AriaComponent, RadarComponent, MarkLineComponent, GraphicComponent,
  DatasetComponent, TransformComponent, PolarComponent, CalendarComponent, MarkPointComponent, MarkAreaComponent
} from 'echarts/components';
import {CanvasRenderer} from 'echarts/renderers';

echarts.use([
  BarChart, LineChart, PieChart, GaugeChart, HeatmapChart, ScatterChart, FunnelChart, TreemapChart, RadarChart,
  SankeyChart, SunburstChart, CustomChart, BoxplotChart, PictorialBarChart,
  GridComponent, TooltipComponent, LegendComponent, TitleComponent, ToolboxComponent,
  DataZoomComponent, VisualMapComponent, AriaComponent, RadarComponent, MarkLineComponent, GraphicComponent,
  DatasetComponent, TransformComponent, PolarComponent, CalendarComponent, MarkPointComponent, MarkAreaComponent,
  CanvasRenderer,
]);

export {echarts};
